import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { settingSelector, fetchSettingDetail, updateSetting } from "../../apps/setting";
import { authSelector } from "../../apps/auth";
import Sidebar from "../../common/Sidebar";
import { HashLoader } from "react-spinners";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";

const EditSetting = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { user, token } = useSelector(authSelector);
    const { settingDetail } = useSelector(settingSelector);

    const [configObject] = useState({
        headers: {
            Authorization: "Bearer " + token,
        },
        params: {},
    });

    console.log(settingDetail)

    // Validation Schema using Yup
    const validationSchema = Yup.object({
        meta_key: Yup.string().required("Required"),
        meta_value: Yup.string().required("Required")
    });

    // Formik Hook
    const formik = useFormik({
        initialValues: {
            meta_key: settingDetail?.meta_key,
            meta_value: settingDetail?.meta_value,
            meta_title: settingDetail?.meta_title,
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            try {
                setLoading(true);
                const resp = await dispatch(updateSetting({ ...values, id }));
                if (resp?.payload?.success) {
                    toast.success('Setting saved successfully');
                    navigate('/settings');
                } else {
                    toast.error(resp?.payload);
                }
            } catch (error) {
                console.log(error)
                toast.error('Some problem exists, Please try again')
            } finally {
                setLoading(false);
            }
        },
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            await dispatch(fetchSettingDetail({
                ...configObject, params: {
                    settingId: id
                },
            }));
        } catch (err) {
        } finally {
            setLoading(false);
        }
    };

    return (

        <div>
            <Sidebar />
            {loading ? (
                <div className="spinner">
                    <HashLoader color="#757575" size={75} loading={true} />
                </div>
            ) : (
                <div className="card">
                    {/* Header */}
                    <div className="card-header bg-white card-header-wrapper py-3">
                        <h3 className="mb-0">Edit Setting</h3>
                    </div>

                    <form onSubmit={formik.handleSubmit} className="p-3">

                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Meta Key:</Form.Label>
                                    <Form.Control
                                        placeholder="Meta key"
                                        value={formik.values.meta_key}
                                        onChange={formik.handleChange}
                                        name="meta_key"
                                        type="text"
                                    />
                                    {formik.errors.meta_key && formik.touched.meta_key && (
                                        <div style={{ color: "red" }}>{formik.errors.meta_key}</div>
                                    )}
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Meta Title:</Form.Label>
                                    <Form.Control
                                        placeholder="Meta Title"
                                        value={formik.values.meta_title}
                                        onChange={formik.handleChange}
                                        name="meta_title"
                                        type="text"
                                    />
                                    {formik.errors.meta_title && formik.touched.meta_title && (
                                        <div style={{ color: "red" }}>{formik.errors.meta_title}</div>
                                    )}
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Meta Value:</Form.Label>
                                    <Form.Control
                                        placeholder="Meta Value"
                                        value={formik.values.meta_value}
                                        onChange={formik.handleChange}
                                        name="meta_value"
                                        as="textarea" rows={3}
                                    />
                                    {formik.errors.meta_value && formik.touched.meta_value && (
                                        <div style={{ color: "red" }}>{formik.errors.meta_value}</div>
                                    )}
                                </Form.Group>
                            </div>
                            <div className="col-md-12 mt-4">
                                {loading ?
                                    <div className="spinner">
                                        <HashLoader color="#757575" size={75} loading={true} />
                                    </div>
                                    :
                                    <Button className="px-4 add_btn" type="submit">
                                        Submit
                                    </Button>
                                }

                            </div>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
};

export default EditSetting;
